/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
constructor() {
  super();
  this.section = this.closest('.js-product');
  this.productForm = this.section.querySelector('.js-product-form-main');
  this.optionSelectors = this.querySelectorAll('.option-selector');
  this.data = this.getProductData();
  this.variant = this.getSelectedVariant();

  // NEU: direkt beim Laden filtern
  if (this.variant) {
    this.updateMedia();
  }

  this.updateAvailability();
  this.updateAddToCartButton();
  this.addEventListener('change', this.handleVariantChange.bind(this));
}

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleUnavailableClick(evt) {
  const opt = evt.target.closest('.js-option');
  if (!opt) return;

  // Als "unverfügbar" markiert? (entspricht deiner updateOptionAvailability-Logik)
  const isUnavailable =
    opt.classList.contains('is-unavailable') ||
    opt.classList.contains('is-nonexistent') ||
    opt.hasAttribute('disabled') ||
    opt.getAttribute('aria-disabled') === 'true';

  if (!isUnavailable) return;

  const selector = opt.closest('.option-selector');
  if (!selector) return;

  // Standardklick unterbinden
  evt.preventDefault();
  evt.stopPropagation();

  // Index der Optionsgruppe (0/1/2) ermitteln
  const selectorIndex = Array.from(this.optionSelectors).indexOf(selector);
  if (selectorIndex < 0) return;

  // Geklickten Wert holen (Dropdown vs. Radio/Chip)
  const clickedValue = selector.dataset.selectorType === 'dropdown'
    ? opt.dataset.value
    : (opt.value ?? opt.getAttribute('value') ?? opt.textContent.trim());

  // Aktuelle Auswahl kopieren und geklickten Wert eintragen
  const desired = this.getSelectedOptions();
  desired[selectorIndex] = clickedValue;

  // 1) Beste passende verfügbare Variante suchen (alle anderen aktuell gewählten Werte beibehalten)
  const variants = this.data.product.variants || [];
  let candidate = variants.find(v => {
    if (!v.available) return false;
    if (v.options[selectorIndex] !== clickedValue) return false;
    for (let i = 0; i < desired.length; i++) {
      if (i === selectorIndex) continue;
      if (desired[i] && v.options[i] !== desired[i]) return false;
    }
    return true;
  });

  // 2) Fallback: irgendeine verfügbare Variante mit dem geklickten Wert
  if (!candidate) {
    candidate = variants.find(v => v.available && v.options[selectorIndex] === clickedValue);
  }
  if (!candidate) return; // keine passende → nichts tun

  // Alle Selektoren auf die gefundene Variante stellen → löst deinen normalen change-Flow aus
  this.optionSelectors.forEach((sel, i) => {
    const val = candidate.options[i];
    if (sel.dataset.selectorType === 'dropdown') {
      const el = sel.querySelector(`.js-option[data-value="${cssEscape(val)}"]`);
      if (el) el.click();
    } else {
      const input = sel.querySelector(`input[type="radio"][value="${cssEscape(val)}"]`);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}
    handleVariantChange(evt) {
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      if (this.variant) {
        setTimeout(() => this.updateMedia(), 0);
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateVariantDescription();
      this.updateVariantTechnicaldetails();
      VariantPicker.updateLabelText(evt);
      this.addEventListener('click', this.handleUnavailableClick.bind(this), true);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
      console.log(this.variant)
    }

updateVariantDescription() {
  console.log("Variante hat sich verändert");
  console.log(this.variant);

  const variantDetails = document.querySelector("#variant_details");

for (const child of variantDetails.children) {
  child.style = "display: none";
}


  let variantDescriptionId = "#variant_description_" + this.variant.id;

  let variantDescription = document.querySelector(variantDescriptionId);

  variantDescription.style = "display: block";
}


updateVariantTechnicaldetails() {
  if (!this.variant) return;

  const container = document.querySelector('#variant_technicaldetails');
  if (!container) return;

  // alles verstecken
  [...container.children].forEach(el => (el.style.display = 'none'));

  // Ziel (Variante) oder Fallback wählen
  let target =
    container.querySelector(`#variant_technicaldetails_${this.variant.id}`);

  const isEmpty = el =>
    !el || !el.innerText || el.innerText.trim().length === 0;

  if (!target || isEmpty(target)) {
    target = container.querySelector('#variant_technicaldetails_fallback');
  }

  if (target && !isEmpty(target)) {
    target.style.display = 'block';
  }
}

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
/**
 * Updates the product media.
 */
updateMedia() {
  if (!this.variant) return;

  // Quick Add Drawer nur Featured
  if (this.section.matches('quick-add-drawer')) {
    if (this.variant.featured_media) {
      this.section.updateMedia(this.variant.featured_media.id);
    }
    return;
  }

  this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
  if (!this.mediaGallery) return;

  const variantIdStr = String(this.variant.id);
  const featuredIdStr = this.variant.featured_media ? String(this.variant.featured_media.id) : null;

  // 1) Featured aktiv setzen
  if (featuredIdStr) {
    const featuredEl = this.mediaGallery.querySelector(`[data-media-id="${featuredIdStr}"]`);
    if (featuredEl) {
      this.mediaGallery.setActiveMedia(featuredEl, true, true);
    }
  }

  // 2) Alle Galerie-Items filtern
  const items = this.mediaGallery.querySelectorAll('.media-viewer__item');
  items.forEach((li) => {
    const id = String(li.getAttribute('data-media-id') || '');
    const isFeatured = featuredIdStr && id === featuredIdStr;
    const isMetafieldImage = id.startsWith(`mf-${variantIdStr}-`);
    const shouldShow = isFeatured || isMetafieldImage;

    li.classList.toggle('hidden', !shouldShow);
    if (!shouldShow) {
      li.classList.remove('is-active', 'is-current-variant');
    }
  });

  // 3) Thumbnails ebenfalls filtern
  const thumbs = this.mediaGallery.querySelectorAll('.media-thumbs [data-media-id]');
  thumbs.forEach((th) => {
    const id = String(th.getAttribute('data-media-id') || '');
    const isFeatured = featuredIdStr && id === featuredIdStr;
    const isMetafieldImage = id.startsWith(`mf-${variantIdStr}-`);
    const shouldShow = isFeatured || isMetafieldImage;
    th.classList.toggle('hidden', !shouldShow);
    if (!shouldShow) {
      th.classList.remove('is-active');
    }
  });
}

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price;
        if (priceWasEl)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        unitPriceEl.hidden = !this.variant.unit_price_measurement;
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available);
      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          selectedOptions.push(selector.querySelector('input:checked').value);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }
function cssEscape(value) {
  if (window.CSS && CSS.escape) return CSS.escape(value);
  return String(value).replace(/[^a-zA-Z0-9_\-]/g, '\\$&');
}
  customElements.define('variant-picker', VariantPicker);
}
